import { get } from 'lodash';
import * as z from 'zod';
import * as ba from './base';
import { SCRIPT_SCHEMA } from '../scripting';
import { assertComponentContext } from '../helpers';
export class ResourceAction extends ba.Action {
    static get manifest() {
        return {
            name: 'resource',
            schema: z.object({
                method: z.union([z.literal('patch'), z.literal('delete')]),
                target: z.union([SCRIPT_SCHEMA(), z.record(z.any())]),
                data: z.union([SCRIPT_SCHEMA(), z.record(z.any())])
            })
        };
    }
    async handle(event, args) {
        assertComponentContext(event.component);
        const conn = event.component.$app.connections.default;
        const target = args.target;
        const url = get(target, 'self', get(target, 'links.self'));
        if (!url) {
            throw new Error('Cannot create request: missing "self" value on data object.');
        }
        const etag = get(target, '$etag', get(target, 'etag'));
        const headers = {};
        if (etag) {
            headers['If-Match'] = etag;
        }
        const response = await conn.ajax({
            url,
            method: args.method,
            headers,
            data: args.data
        });
        await this.dispatch('success', response);
        return response;
    }
}
//# sourceMappingURL=resource.js.map